import { IModule, IModuleBuilder } from "app/IModule";
import { PositionReducer, PositionSettingConfigurationReducer } from "features/positions/positionSettings.reducers";
import { PositionBalanceReducer } from "./positionBalances.reducers";
import { PositionHedgeReducer } from "./positionHedges.reducer";
import { PositionGroupsReducer } from "./positionGroups.reducer";
import permissions from "common/security/permissions";
import React from "react";

export default class LongShortModule implements IModule {
  build(builder: IModuleBuilder) {
    builder.addPermissionedRoute("/positions", permissions.ViewPosition, React.lazy(() => import("./Positions.page")));
    builder.addReducer("positionSettings", new PositionReducer());
    builder.addReducer("positionBalances", new PositionBalanceReducer());
    builder.addReducer("positionHedges", new PositionHedgeReducer());
    builder.addReducer("positionSettingConfiguration", new PositionSettingConfigurationReducer());
    builder.addReducer("positionGroups", new PositionGroupsReducer());
  }
}